/** Readers for GitHub content (or its card), shared by the frame and its card preview. */
import type { Commit } from "./commits-section";
import type { PullRequest } from "./pr-section";

/** `content.pr`: an array, or a single object on legacy frames. */
export function pullRequestsFrom(value: unknown): PullRequest[] {
  if (Array.isArray(value)) return value as PullRequest[];
  return value ? [value as PullRequest] : [];
}

export function commitsFrom(value: unknown): Commit[] {
  return Array.isArray(value) ? (value as Commit[]) : [];
}
